module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Other2-1fbe891e4a940b29fb40f651954c7054.svg";